// MUI Icons
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import TitleIcon from '@mui/icons-material/Title';

// Map Quill format names to MUI Icon components
export const muiIconComponents: { [key: string]: React.ComponentType<any> } = {
  bold: FormatBoldIcon,
  italic: FormatItalicIcon,
  strike: StrikethroughSIcon,
  link: InsertLinkIcon,
  'list-ordered': FormatListNumberedIcon,
  'list-bullet': FormatListBulletedIcon,
  title: TitleIcon,
};

// Default editing options
export const DEFAULT_EDITING_OPTIONS = [
  'title',
  'bold',
  'italic',
  'strikethrough',
  'link',
  'numberList',
  'bulletList',
  'emoji',
];

// Standard button selectors for Quill toolbar
export const STANDARD_BUTTON_SELECTORS = [
  '.ql-bold',
  '.ql-italic',
  '.ql-strike',
  '.ql-link',
  '.ql-list[value="ordered"]',
  '.ql-list[value="bullet"]',
];

// Button styling constants
export const BUTTON_SIZE = 40;
export const BUTTON_MARGIN = '0 1px';
export const TOOLBAR_MIN_HEIGHT = 56;
export const TOOLBAR_PADDING = 8;
